import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCopy(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1H15L20 6V16C20 17 19 18 18 18H8C7 18 6 17 6 16V3C6 2 7 1 8 1ZM8 16H18V7H14V3H8V16Z"
        fill="currentColor"
      />
      <path
        d="M2 9C2 8.44772 2.44772 8 3 8C3.55228 8 4 8.44772 4 9V20H16C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H4C2.89543 22 2 21.1046 2 20V9Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
